import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
import { ProductSearchQueriesSection } from "../ProductSearchQueriesSection.js";
function SearchProductsPart({
  part,
  allParts,
  onProductClick,
  isStreaming
}) {
  var _a, _b, _c, _d;
  const searchQueryResults = allParts.filter((p) => p.type === "data-search-query-result").map((p) => p.data);
  const searchAngles = (_a = part.input) == null ? void 0 : _a.searchAngles;
  const hasAngles = Array.isArray(searchAngles) && searchAngles.length > 0;
  if (hasAngles) {
    const previewSearchQueries = searchAngles.map(
      (a) => (a.product || "").trim()
    );
    const isSearchActive = isCallState(part.state);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        ProductSearchQueriesSection,
        {
          previewSearchQueries,
          previewQueryProducts: searchQueryResults,
          isStreaming: isSearchActive,
          hasContent: !isSearchActive
        }
      ),
      isOutputState(part.state) && ((_b = part.output) == null ? void 0 : _b.noRelevantProducts) && /* @__PURE__ */ jsx("div", { className: "concierge-no-results", children: "No relevant products found for this search." })
    ] });
  }
  if (isCallState(part.state)) {
    const query = ((_c = part.input) == null ? void 0 : _c.query) || "products";
    return /* @__PURE__ */ jsx("div", { className: "concierge-search-loading", children: /* @__PURE__ */ jsxs("div", { className: "concierge-search-loading-text", children: [
      "Searching for ",
      query,
      "..."
    ] }) });
  }
  if (isOutputState(part.state) && ((_d = part.output) == null ? void 0 : _d.noRelevantProducts)) {
    return /* @__PURE__ */ jsx("div", { className: "concierge-no-results", children: "No relevant products found for this search." });
  }
  return null;
}
export {
  SearchProductsPart
};
//# sourceMappingURL=SearchProductsPart.js.map
